const o = 10, t = 10, c = 10485760;
export {
  t as MAX_DOWNLOAD_FILE_SIZE,
  o as MAX_FILES,
  c as MAX_FILE_SIZE
};
//# sourceMappingURL=constants.js.map
